import React, { useState, useEffect, useCallback } from 'react';
import inventoryService from '../../services/inventoryService';

const SkuSearchModal = ({ initialSku, onProductSelect, onCancel, activeStore }) => {
  const [searchTerm, setSearchTerm] = useState(initialSku || '');
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleSearch = useCallback(async () => {
    if (!searchTerm || !activeStore) return;
    setIsLoading(true);
    try {
      const products = await inventoryService.searchProducts(activeStore._id, searchTerm);
      setResults(products);
    } catch (error) {
      console.error("Failed to search products", error);
      setResults([]); // Clear results on error
    } finally {
      setIsLoading(false);
    }
  }, [searchTerm, activeStore]);

  useEffect(() => {
    if (searchTerm) {
      handleSearch();
    }
  }, [searchTerm, handleSearch]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-start pt-20">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-lg">
        <h2 className="text-xl font-bold mb-4">Product Not Found - Manual Search</h2>
        <div className="flex space-x-2 mb-4">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full border-gray-300 rounded-md shadow-sm"
            placeholder="Search by SKU or Name..."
            autoFocus // Automatically focus the input
          />
          <button onClick={handleSearch} disabled={isLoading || !searchTerm} className="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-dark disabled:bg-gray-400">
            {isLoading ? 'Searching...' : 'Search'}
          </button>
        </div>
        <div className="h-64 overflow-y-auto border rounded-md">
          {isLoading ? (
            <p className="p-4 text-gray-500">Searching...</p>
          ) : results.length > 0 ? (
            results.map(product => (
              <div key={product._id} onClick={() => onProductSelect(product)} className="p-3 hover:bg-gray-100 cursor-pointer border-b">
                <p className="font-semibold">{product.name}</p>
                <p className="text-sm text-gray-600">SKU: {product.sku} | Stock: {product.stock}</p>
              </div>
            ))
          ) : (
            <p className="p-4 text-gray-500">No products found for "{searchTerm}" in this store.</p>
          )}
        </div>
        <button onClick={onCancel} className="w-full mt-4 text-center text-gray-600 py-2">Close</button>
      </div>
    </div>
  );
};

export default SkuSearchModal;
